import { Box, styled } from '@mui/material';

export const InfoBannerContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: theme.palette.grey[800],
  padding: theme.spacing(1, 2),
  [theme.breakpoints.down('sm')]: {
    width: 'calc(100% - 32px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'center',
    padding: theme.spacing(3),
    margin: theme.spacing(2),
    borderRadius: theme.spacing(2),
  },
}));
